module.exports = __webpack_public_path__ + "img/624-42dfb3.png";